module.exports = __webpack_public_path__ + "img/HUN.6125edfb.png";